import React, { Component } from 'react';
// eslint-disable-next-line
import defaultOptions from './particle_json/default_options.js';
import './style.scss';
import { v4 as uuid } from 'uuid';
class ParticlesContainer extends Component {
    constructor() {
        super();

        this.state = {
            mounted: false
        }
    }
    componentDidMount() {
        this.setState({ mounted: true });
    }

    loadParticleJs() {
        // if (this.state.mounted) {
        //     return <Particles
        //         particlesRef={this.props.farwardRef}
        //         canvasClassName="particles-background"
        //         height="100%"
        //         width="100%"
        //         params={this.props.options ? { ...this.props.options } : defaultOptions}
        //     />
        // }
    }
    render() {
        const id = this.props.id ? this.props.id : uuid();
        // alert(id)
        return (
            <div
                id={id}
                key={id}
                className={this.props.className}
                onClick={(e) => {
                    e.stopPropagation();
                    this.props.onClick && this.props.onClick()
                }}
                style={{
                    height: '100%',
                    width: '100%',
                    ...this.props.style
                }}
            >
                {this.loadParticleJs()}
                {this.props.children}
            </div>
        )
    }
}

export default ParticlesContainer;